// Session
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const SAVE_STUDENT = 'SAVE_STUDENT';
export const RESET_PASSWORD = 'RESET_PASSWORD';

// Errors
export const SHOW_ERROR = 'SHOW_ERROR';
export const DISMISS_ERROR = 'DISMISS_ERROR';
